import React from 'react';
import moment from 'moment-timezone';
import { Card, Col, Row, Space, Typography } from 'antd';
import { campaignTypeMap } from '../../../core/utils/constants/constants';
import { formatCurrency2SigFig } from '../../../core/utils/campaigns';
import { useTimezone } from '../../../core/hooks/useTimezone';
import './styles.css';

const { Text } = Typography;

const CampaignRequestorReviewDetails = ({ formValues }) => {
  const { timezone } = useTimezone();
  // Extract data directly from formValues (no form dependency)
  const {
    name = '',
    description = '',
    type: campaignType = 1,
    startDate,
    endDate,
    budget = 0,
    advertiser,
    IONumber = '',
    renewalStatus = '',
  } = formValues || {};

  return (
    <Card title="CAMPAIGN ORDER & BUDGET ALLOCATION">
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {/* Advertiser and Campaign Name Row */}
        <Row gutter={20}>
          <Col span={6}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Text type="secondary">Advertiser</Text>
              <Text style={{ fontSize: '14px' }}>{advertiser?.name || 'Not specified'}</Text>
            </Space>
          </Col>
          <Col span={6}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Text type="secondary">Campaign Name</Text>
              <Text style={{ fontSize: '14px' }}>{name || 'Untitled Campaign'}</Text>
            </Space>
          </Col>
          <Col span={12}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Text type="secondary">Description</Text>
              <Text style={{ fontSize: '14px' }}>{description || 'No description provided'}</Text>
            </Space>
          </Col>
        </Row>

        {/* Campaign Details Row */}
        <Row gutter={20}>
          <Col span={6}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Text type="secondary">Campaign Type</Text>
              <Text style={{ fontSize: '14px' }}>{campaignTypeMap[campaignType] || 'DISPLAY'}</Text>
            </Space>
          </Col>
          <Col span={6}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Text type="secondary">Duration</Text>
              <Text style={{ fontSize: '14px' }}>
                {startDate && endDate
                  ? `${moment(startDate).tz(timezone).format('MM/DD/YYYY')} - ${moment(endDate).tz(timezone).format('MM/DD/YYYY')}`
                  : 'Not specified'
                }
              </Text>
            </Space>
          </Col>
          <Col span={6}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Text type="secondary">IO Number</Text>
              <Text style={{ fontSize: '14px' }}>{IONumber || 'Not provided'}</Text>
            </Space>
          </Col>
          <Col span={6}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Text type="secondary">Renewal Status</Text>
              <Text style={{ fontSize: '14px' }}>{renewalStatus || 'Not specified'}</Text>
            </Space>
          </Col>
        </Row>

        {/* Campaign Budget Row */}
        <Row gutter={20}>
          <Col span={6}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Text type="secondary">Campaign Budget</Text>
              <Text style={{ fontSize: '14px', fontWeight: 'bold' }}>
                {formatCurrency2SigFig(budget)}
              </Text>
            </Space>
          </Col>
        </Row>
      </Space>
    </Card>
  );
};

export default CampaignRequestorReviewDetails;